var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-title',{attrs:{"title":"Dashboard"}}),_c('base-empty',{attrs:{"title":"Você ainda não possui nenhum Dashboard.","message":"Dashboards personalizados para o seu negócio."}},[_c('template',{slot:"image"},[_c('i',{staticClass:"far fa-house-blank"})])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }